export default __webpack_public_path__ + "static/media/screen-manager.48f4b1eb.svg";